export enum AddUserFormEnums {
  IMAGE_ALT = 'Carbon one',
  HEADING = 'Add user',
  SUBHEADING = 'When you login next time,use the created password to login',
  SUBHEADING_SPAN = 'Signup',
  HELPER_TEXT = 'Forgot Password',
  BUTTON_LABEL_SUBMIT = 'Confirm',
  BUTTON_LABEL_BACK = 'Back'
}